<template>
  <div class="chosen-fieldset" :class="blockClasses" ref="root">
    <div class="chosen-fieldset__fields"
         :class="elementClasses('fields')"
    >
      <!-- Тут костыль, чтобы не верстать отдельную ссылку под очиститель - не трогайте лейбл внутри ссылки )) -->
      <a :href="currentUrl" class="chosen-fieldset__clear-all chosen-field"
         v-if="this.hasVisibleFields() === true"
      >
        <label>
          <span class="chosen-field__closer">
          </span>
        </label>
      </a>

      <div class="chosen-fieldset__field"
           :class="[...elementClasses('field'), ...elementClasses('field_' + field.key)]"
           v-for="field in fields"
      >
        <Field v-if="field.visible" :fieldKey="field.key" :filterKey="filterKey" @change="debouncedChange"/>
      </div>

    </div>
  </div>
</template>

<script>
  import {fieldsetMixin} from "./fieldsetMixin";
  import Field from "../field/Field.vue";
  import { FilterManagerPool } from "../manager";
  import { debounce } from "lodash";

  export default {
    name: "ChosenFieldset",
    components: {Field},
    mixins: [
      fieldsetMixin
    ],
    computed: {
      currentUrl() {
        return window.location.href;
      },
    },
    methods: {
      change() {
        if (this.fieldset.data.instantСhangeable) {
          this.manager.submit();
        }
      },
      hasVisibleFields() {
        let isVisible = false;
        if (this.fields) {
          this.fields.forEach((element) => {
            if (element.visible === true) {
              isVisible = true;
            }
          })
        }

        return isVisible;
      },
      debouncedChange: debounce(function() {
        this.change();
      }, 300),
    },
    mounted() {
      this.manager = FilterManagerPool.getManager(this.filterKey);
    },
  }
</script>

<style lang="scss">

</style>